import * as React from 'react';
import type { } from '@mui/x-date-pickers/themeAugmentation';
import type { } from '@mui/x-charts/themeAugmentation';
import type { } from '@mui/x-data-grid-pro/themeAugmentation';
import type { } from '@mui/x-tree-view/themeAugmentation';
import { alpha } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import AppNavbar from '../../components/AppNavbar';
import Header from '../../components/Header';
import SideMenu from '../../components/SideMenu';
import AppTheme from '../../shared-theme/AppTheme';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getUser } from '../getUserDB';
import LoadingCircular from '../../components/LoadingCircular';
import { Button, Container, Typography } from '@mui/material';
import logoCabanaWhite from '../../images/logonextcabana-white.svg';
import FlowAreaCard from '../../components/FlowAreaCard';

export default function FlowModels(props: { disableCustomTheme?: boolean }) {
  const [isAcitve, setIsActive] = useState<boolean | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const dataUser = async () => {
      const data = await getUser();
      if (data.status !== 'ativo') {
        setIsActive(false);
      } else {
        setIsActive(true);
      }
    }
    dataUser();
  }, []);

  if (isAcitve === false) {
    return (
      <AppTheme {...props}>
        <Container
          component="main"
          sx={{
            maxWidth: 'xs',
            textAlign: 'center',
            display: 'flex',
            flexDirection: 'column',
            gap: 2
          }}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              marginTop: '40px',
              marginBottom: '40px'
            }}
          >
            <img
              src={logoCabanaWhite}
              alt="logo-cabanalink"
              style={{ width: '300px', height: 'auto' }}
            />
          </div>
          <Typography variant="h5">Área exclusiva para usuários ativos.</Typography>
          <Button
            onClick={() => navigate('/payment')}
            variant="contained"
            sx={{ width: '250px', alignSelf: 'center' }}
          >
            Regularize seu pagamento
          </Button>
        </Container>
      </AppTheme>
    );
  }

  if (isAcitve === null) {
    return (
      <LoadingCircular />
    )
  }

  return (
    <AppTheme {...props}>
    <CssBaseline enableColorScheme />
    <Box sx={{ display: 'flex' }}>
      <SideMenu />
      <AppNavbar />
      <Box
        component="main"
        sx={(theme: any) => ({
          flexGrow: 1,
          backgroundColor: theme.vars
            ? `rgba(${theme.vars.palette.background.defaultChannel} / 1)`
            : alpha(theme.palette.background.default, 1),
          overflow: 'auto',
        })}
      >
        <Stack
          spacing={2}
          sx={{
            alignItems: 'center',
            mx: 3,
            pb: 5,
            mt: { xs: 8, md: 0 },
          }}
        >
          <Header />
          <FlowAreaCard />
        </Stack>
      </Box>
    </Box>
  </AppTheme>
  );
}